/**
 * ─── SINGLE SOURCE OF TRUTH FOR ALL SUPPORTED LANGUAGES ─────────────────────
 *
 * To add a new language:
 *  1. Add one entry to LANG_CONFIGS below (code, label, short, flag, locale).
 *  2. Add translated URL slugs for the new language in shared/route-slugs.ts.
 *  3. Add guide slug translations in shared/guide-slug-data.ts.
 *  4. Add the locale's Intl string to server/routes/api-translations.ts
 *     (the LANGS const is now derived automatically, but the DB stores
 *     strings per-lang so the backend must recognise the code).
 *
 * Everything else — routing, language switcher UI, SEO alternate URLs,
 * IndexNow submissions, and the translation API — picks up the new language
 * automatically from this file.
 */

export const LANG_CONFIGS = [
  { code: "en" as const, label: "English",    short: "EN", flag: "🇬🇧", locale: "en-GB" },
  { code: "de" as const, label: "Deutsch",    short: "DE", flag: "🇩🇪", locale: "de-DE" },
  { code: "fr" as const, label: "Français",   short: "FR", flag: "🇫🇷", locale: "fr-FR" },
  { code: "it" as const, label: "Italiano",   short: "IT", flag: "🇮🇹", locale: "it-IT" },
  { code: "nl" as const, label: "Nederlands", short: "NL", flag: "🇳🇱", locale: "nl-NL" },
  { code: "hr" as const, label: "Hrvatski",   short: "HR", flag: "🇭🇷", locale: "hr-HR" },
  { code: "pl" as const, label: "Polski",     short: "PL", flag: "🇵🇱", locale: "pl-PL" },
] as const;

export type SiteLang   = typeof LANG_CONFIGS[number]["code"];
export type NonEnLang  = Exclude<SiteLang, "en">;

export const ALL_LANG_CODES: SiteLang[]    = LANG_CONFIGS.map(l => l.code) as SiteLang[];
export const NON_EN_LANG_CODES: NonEnLang[] = LANG_CONFIGS.filter(l => l.code !== "en").map(l => l.code) as NonEnLang[];

export const LOCALE_BY_CODE: Record<SiteLang, string> = Object.fromEntries(
  LANG_CONFIGS.map(l => [l.code, l.locale])
) as Record<SiteLang, string>;
